import { create } from 'zustand'

export const useUIStore = create((set) => ({
  toast: null,
  sidebarOpen: true,
  
  showToast: (message, type = 'info') => {
    set({ toast: { message, type, id: Date.now() } })
    setTimeout(() => set({ toast: null }), 3000)
  },
  
  hideToast: () => set({ toast: null }),
  
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  
  setSidebarOpen: (isOpen) => set({ sidebarOpen: isOpen }),
}))